import { render, staticRenderFns } from "./SystemHome.vue?vue&type=template&id=3eb87304&scoped=true&"
import script from "./SystemHome.vue?vue&type=script&lang=js&"
export * from "./SystemHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eb87304",
  null
  
)

export default component.exports